export enum OrderDirections {
  ASC = 'asc',
  DESC = 'desc',
}

export const ORDER_DIRECTIONS = [
  { label: 'Сначало новые', value: OrderDirections.DESC },
  { label: 'Сначало старые', value: OrderDirections.ASC },
];
